import PropTypes from 'prop-types';
import React from 'react';

import Box from '@mui/material/Box';
import MosaicList from './mosaic-list';
import SelectionMode from './selection-mode';

import {connect} from 'react-redux';
import {modes} from '../actions/ui';

const Sidebar = props => {
  const selectionMode = props.mode === modes.SELECTION;
  return (
    <Box width={400}>
      <MosaicList open />
      <SelectionMode open={selectionMode} />
    </Box>
  );
};

Sidebar.propTypes = {
  mode: PropTypes.string.isRequired,
};

const mapStateToProps = ({ui}) => ({
  mode: ui.mode,
});

export default connect(mapStateToProps)(Sidebar);
